import { GenericProvider, Provider } from "@/services/data/generic-provider";
import { baseAPIUrl } from "@/services/utils/utils";
import { IAdminConfirmationResponse } from "./admin-confirm.types";

@Provider(`${baseAPIUrl}/admin/auth/confirm`)
class AdminConfirmProvider extends GenericProvider<IAdminConfirmationResponse> {}

export const adminConfirmProvider = new AdminConfirmProvider();
